import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Payment, Transaction } from '../../models';
import { TokenServiceService } from '../../services/token-service.service';
import { BuyerInformationComponent } from '../buyer-information/buyer-information.component';
import { AlertService } from 'src/app/services/alert.service';
import { environment } from 'src/environments/environment';
import { ALERT_ICON_CONSTANTS, API_PATHS, debugLog, FLUTTER_API_PAY_IN_STATUS, FLUTTER_POST_MESSAGE_TO_SEND, FLUTTER_POST_MESSAGE_TYPES } from 'src/app/core/constants/General-constants';
import { BehaviorSubject } from 'rxjs';
import { ALERT_ERRORS } from 'src/app/core/constants/Errors';

@Component({
    selector: 'app-embebed-api-pay-in',
    templateUrl: './api-pay-in.component.html',
    styleUrls: ['./api-pay-in.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: Window, useValue: window }],
})
export class EmbebedApiPayInComponent implements OnInit {
    private isVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    token: string;

    @Input()
    set isVisible(value: boolean) { this.isVisible$.next(value); }

    get isVisible(): boolean { return this.isVisible$.value; }

    @Input() info: Payment;
    @Output() APIPAYIN = new EventEmitter();
    @ViewChild(BuyerInformationComponent)
    apiPayInIframeElement: HTMLIFrameElement;

    transaction: Transaction;
    loading = true;
    response: any;
    iframeUrl: string = '';

    constructor(private tokenService: TokenServiceService, private readonly alertService: AlertService) {}

    async ngOnInit() {
        this.transaction = this.tokenService.getAndDecodeToken();
        this.iframeUrl = `${environment.modulesPayvalidaUrl}${API_PATHS.apiPayInForm}`;
        document.getElementById('apiPayInIframe').onload = () => {
            this.apiPayInIframeElement = document.getElementById('apiPayInIframe') as HTMLIFrameElement;

            this.apiPayInIframeElement.contentWindow.postMessage(
                JSON.stringify({
                    type: FLUTTER_POST_MESSAGE_TO_SEND.LOAD_WEB_SCRIPT,
                }),
                environment.modulesPayvalidaUrl
            );
        };

        this.onActivate();
    }

    changeMethod() {
        this.APIPAYIN.emit();
    }

    onActivate() {
        window.scroll(0, 0);

        window.addEventListener('message', async (event) => {
            debugLog({ event, info: this.info });

            if (event.origin !== environment.modulesPayvalidaUrl) return;

            let data = JSON.parse(event.data);

            if (data.src !== API_PATHS.apiPayInForm) return;

            switch (data.type) {
                case FLUTTER_POST_MESSAGE_TYPES.IS_LOADING:
                    this.loading = data.data;
                    break;
                case FLUTTER_POST_MESSAGE_TYPES.FORM_READY:
                    this.transaction = this.tokenService.getAndDecodeToken();

                    debugLog({ transaction: this.transaction });

                    this.token = this.tokenService.getToken();

                    let userInformation = {
                      token: this.token,
                      network_code: this.info.code,
                      country_code: Number(this.transaction.COUNTRY_CODE)
                    };

                    debugLog(
                        JSON.stringify({
                            type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
                            data: userInformation,
                        })
                    );

                    this.apiPayInIframeElement.contentWindow.postMessage(
                        JSON.stringify({
                            type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
                            data: userInformation,
                        }),
                        environment.modulesPayvalidaUrl
                    );
                    break;
                case FLUTTER_POST_MESSAGE_TYPES.ERROR:
                    this.loading = false;

                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR);
                    break;
                case FLUTTER_POST_MESSAGE_TYPES.CONTENT_SIZE:
                    this.apiPayInIframeElement.setAttribute('height', data.data);
                    break;
                case FLUTTER_POST_MESSAGE_TYPES.COMPLETE:

                    this.response = { responseData: data.data };

                    switch (this.response.responseData.status) {
                      case FLUTTER_API_PAY_IN_STATUS.PENDING_EXTERNAL_PAYMENT_FLOW:
                        this.loading = false;
                        let transactionDetails = {
                          transactionId: this.response.responseData.transactionId,
                          token: this.token
                        }

                        transactionDetails = { ...transactionDetails, ...this.transaction };

                        localStorage.setItem( `${FLUTTER_API_PAY_IN_STATUS.PENDING_EXTERNAL_PAYMENT_FLOW}`, JSON.stringify({transactionDetails: transactionDetails}));

                        return window.location.href = this.response.responseData.url;

                      case FLUTTER_API_PAY_IN_STATUS.FAILED:
                        this.loading = false;

                        return this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.ERROR, ALERT_ERRORS.SORRY_ALERT);

                      case FLUTTER_API_PAY_IN_STATUS.ORDER_ALREADY_PAID:
                        this.loading = false;

                        return this.alertService.showAlert(ALERT_ERRORS.ERROR_ALREADY_PAID, ALERT_ICON_CONSTANTS.WARNING, ALERT_ERRORS.SORRY_ALERT);

                      default:
                        this.loading = false;

                        return this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.ERROR, ALERT_ERRORS.SORRY_ALERT);
                    }

                default:
                    break;
            }
        });
    }
}
